import { style, styleVariants } from '@vanilla-extract/css';
import { semanticTokenVars } from '@tundr/ds-tokens';
import {
  fontFamilyVars,
  fontWeightVars,
  fontSizeVars,
  lineHeightVars,
  spacingVars,
  radiusVars,
} from '@tundr/ds-foundations';

export const positionerClass = style({
  zIndex: 9999,
});

export const contentClass = style({
  display: 'inline-flex',
  flexDirection: 'column',
  gap: spacingVars.xs,
  backgroundColor: semanticTokenVars.surface.background.neutral.default.inverse,
  color: semanticTokenVars.content.default.onInverse,
  borderRadius: radiusVars.md,
  paddingBlock: spacingVars.sm,
  paddingInline: spacingVars.md,
  fontFamily: fontFamilyVars.body,
  letterSpacing: '0.14px',
  maxWidth: '320px',
  width: 'fit-content',
  selectors: {
    '&[hidden]': {
      display: 'none',
    },
  },
});

export const contentSizeClasses = styleVariants({
  md: {
    fontSize: fontSizeVars.body.body2,
    lineHeight: lineHeightVars.body.body2,
  },
  sm: {
    fontSize: fontSizeVars.body.body3,
    lineHeight: lineHeightVars.body.body3,
  },
});

export const titleClass = style({
  fontWeight: fontWeightVars.bold,
});

export const descriptionClass = style({
  fontWeight: fontWeightVars.regular,
  whiteSpace: 'pre-line',
});

export const arrowClass = style({
  width: '10px',
  height: '10px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const arrowTipClass = style({
  width: '10px',
  height: '10px',
  backgroundColor: semanticTokenVars.surface.background.neutral.default.inverse,
  borderRadius: '1px',
  transform: 'rotate(45deg)',
});
